/* eslint-disable react/no-multi-comp, react/prop-types */

// Modules
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { AmazonOrderDetailsLink } from 'components/widgets/icons/link-icons';
import { LinkButton } from 'components/widgets/buttons';
import { SHORT_HUMAN_DATE_FORMAT } from 'constants';
import { TableCard } from 'components/content-containers/cards';
import { alerts } from 'modules/alerts/actions';
import ArchivedItem from 'components/archived-items';
import CompanyNickname from 'components/models/company/company-nickname';
import PurchaseOrder from 'services/data/purchase-order';
import SVG from 'components/widgets/icons/svg';
import TicketLink from 'components/models/ticket/ticket-link';

import EditPurchaseOrder from './edit-purchase-order';
import ExpenseBills from './expense-bills';
import PurchaseCardHeader from './purchase-card-header';
import PurchaseLineItems from './purchase-line-items';
import PurchaseMetadata from './purchase-metadata';
import Returns from './returns';


export default class PurchaseCard extends React.Component {
  static propTypes = {
    purchaseOrder: PropTypes.shape({
      update: PropTypes.func.isRequired
    }).isRequired
  }

  constructor() {
    super();
    this.state = { edit: false };
  }

  render() {
    const { purchaseOrder } = this.props;
    const { ticket, date, vendor, company, approvedBy, createdBy, replenishment, vendorOrderId } = purchaseOrder;

    if (purchaseOrder.recentlyArchived) {
      return (
        <ArchivedItem component={TableCard}>
          <PurchaseCardHeader purchaseOrder={purchaseOrder} />
          <ArchivedBanner id={purchaseOrder.id} updatePurchaseOrder={purchaseOrder.update} />
        </ArchivedItem>
      );
    }

    return (
      <TableCard className="purchase-card">
        <PurchaseCardHeader
          purchaseOrder={purchaseOrder}
          edit={!this.state.edit ? () => this.setState({ edit: true }) : false}
        />
        { purchaseOrder.status === 'Archived' &&
          <ArchivedBanner id={purchaseOrder.id} updatePurchaseOrder={purchaseOrder.update} />
        }
        { this.state.edit &&
          <EditPurchaseOrder purchaseOrder={purchaseOrder} cancel={() => this.setState({ edit: false })} />
        }
        { !this.state.edit &&
          <div>
            <PurchaseMetadata
              company={<CompanyNickname company={company} />}
              ticket={<TicketLink ticket={ticket} />}
              date={moment(date).format(SHORT_HUMAN_DATE_FORMAT)}
              purchasedBy={!_.isEmpty(createdBy) ? `${createdBy.firstName} ${createdBy.lastName}` : ''}
              vendor={
                <span>
                  {vendor} {(vendor === 'Amazon' && vendorOrderId) && <AmazonOrderDetailsLink vendorOrderId={vendorOrderId} />}
                </span>
              }
              approvedBy={approvedBy}
              replenishment={replenishment && <SVG src="svg/check.svg" />}
            />
            <PurchaseLineItems purchaseOrder={purchaseOrder} />
          </div>
        }
        <ExpenseBills purchaseOrder={purchaseOrder} />
        <Returns purchaseOrder={purchaseOrder} />
      </TableCard>
    );
  }
}


function ArchivedBanner({ id, updatePurchaseOrder }) {
  return (
    <div className="archived-item-banner">
      <LinkButton
        onClick={() =>
          PurchaseOrder.update({ id, status: 'Active' })
            .then(() => PurchaseOrder.findOne(id, PurchaseOrder.defaultQuery))
            .then(updatePurchaseOrder)
            .catch(alerts.catchError)
        }
      >
        Restore
      </LinkButton>
    </div>
  );
}
